import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { EventOutcomePriority } from '../event-outcome/event-outcome.types';
import {
  EVENT_OUTCOME_GROUP_BORDER_COLORS,
  EVENT_OUTCOME_GROUP_COLORS,
} from '../event-outcome/event-outcome.types';

@Component({
  selector: 'eventq-resolve-queue-row',
  templateUrl: './resolve-queue-row.html',
  styleUrl: './resolve-queue-row.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-resolve-queue-row-host--clickable]': 'clickable() && !loading()',
  },
})
export class EventqResolveQueueRow {
  readonly siteName = input('');
  readonly siteCode = input('');
  readonly eventType = input('');
  readonly timestamp = input('');
  /** Optional secondary line (e.g. who is working / who parked). */
  readonly metaLine = input<string | null>(null);
  readonly priority = input<EventOutcomePriority>('p1');
  readonly clickable = input(false);
  /** Renders a colored skeleton placeholder with the same footprint as a real row. */
  readonly loading = input(false);

  readonly selected = output<void>();

  readonly rowStyle = computed(() => {
    const priority = this.priority();
    return {
      '--eventq-resolve-queue-row-bg': EVENT_OUTCOME_GROUP_COLORS[priority],
      '--eventq-resolve-queue-row-border': EVENT_OUTCOME_GROUP_BORDER_COLORS[priority],
    };
  });

  onActivate(): void {
    if (!this.clickable() || this.loading()) {
      return;
    }
    this.selected.emit();
  }
}
